export const config = {
    apiKey: "AIzaSyAg4-SJ4lXFcBbyhszhac21Z8V-UEQ5Tdk",
    authDomain: "swipe-app-woudhuis.firebaseapp.com",
    projectId: "swipe-app-woudhuis",
    storageBucket: "swipe-app-woudhuis.appspot.com",
    messagingSenderId: "217813935531",
    appId: "1:217813935531:web:ff7dd439f9af9dbdea1eee",
};
